import React, { ChangeEvent } from 'react';

import FormElementWrapper from './FormElementWrapper';

interface CheckboxProps {
    checkboxValidationState?: string,
    checkboxId: string,
    checkboxName?: string,
    checkboxLabel?: string,
    notRequired?: boolean,
    prefixIcon?: string,
    suffixIcon?: string,
    checkboxValidationMessage?: string,
    elementCustomClass?: string,
    isDisabled?: boolean,
    checkboxSize?: string,
    // checkboxType?: string,
    // checkboxPlaceholder?: string,
    checkboxDefaultValue?: boolean,
    checkboxCustomClass?: string,
    // eslint-disable-next-line no-unused-vars
    checkboxOnChange?: (event: ChangeEvent) => void
}

const Checkbox = (props: CheckboxProps) => {
    const {
        checkboxValidationState,
        checkboxId,
        checkboxName,
        checkboxLabel,
        notRequired,
        prefixIcon,
        suffixIcon,
        checkboxValidationMessage,
        elementCustomClass,
        isDisabled,
        checkboxSize,
        // checkboxType,
        // checkboxPlaceholder,
        checkboxDefaultValue,
        checkboxCustomClass,
        checkboxOnChange
    } = props;

    return (
        <FormElementWrapper
            elementValidationState={checkboxValidationState}
            elementId={checkboxId}
            notRequired={notRequired}
            prefixIcon={prefixIcon}
            suffixIcon={suffixIcon}
            elementValidationMessage={checkboxValidationMessage}
            elementCustomClass={elementCustomClass}
            isDisabled={isDisabled}
            elementSize={checkboxSize}
        >
            {/* <input
                type={inputType}
                id={inputId}
                placeholder={inputPlaceholder}
                required={!notRequired}
                value={inputValue}
                className={inputCustomClass}
                onChange={inputOnChange}
            /> */}
            <div className={`checkbox${isDisabled ? ' is-disabled' : ''}${checkboxValidationState ? ` validation-${checkboxValidationState}` : ''} ${checkboxCustomClass}`}>
                <input
                    type="checkbox"
                    id={checkboxId}
                    name={checkboxName ? checkboxName : checkboxId}
                    disabled={isDisabled}
                    required={!notRequired}
                    className="sr-only"
                    defaultChecked={checkboxDefaultValue}
                    onChange={checkboxOnChange}
                    // {{#if value}}value="{{value}}"{{/if}}
                />
                <label
                    htmlFor={checkboxId}
                    aria-disabled={isDisabled}
                >
                    {checkboxLabel}
                    {/* {{#if notRequired}} <span className="form-optional">(optional)</span>{{/if}} */}
                </label>
                {checkboxValidationMessage && (
                    <div className="validation-message">{checkboxValidationMessage}</div>
                )}
            </div>
        </FormElementWrapper>
    );
};

export default Checkbox;
